import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Radio } from "antd";
import { useEnigmaToken } from "@hooks/useEnigmaToken";

const sizeMap = {
    medium: {
        dimension: "fontSizeLG",
    },
    large: {
        dimension: "fontSizeXL",
    },
};

const getRadioDotCss = (size, bgColor, disabled) => {
    const token = useEnigmaToken();
    return css`
        width: ${token[sizeMap[size].dimension]}px;
        height: ${token[sizeMap[size].dimension]}px;
        margin-block-start: -${token[sizeMap[size].dimension] / 2}px;
        margin-inline-start: -${token[sizeMap[size].dimension] / 2}px;
        background-color: ${!disabled && bgColor};
    `;
};

const getRadioCSS = (size: string, disabled: boolean, checked: boolean) => {
    const token = useEnigmaToken();
    const dimension = token[sizeMap[size].dimension];
    return css`
        .ant-radio-checked:not(.ant-radio-disabled) {
            .ant-radio-inner.ant-radio-inner {
                background-color: ${token.color?.Selection?.selectionBgFill};
            }
        }

        .ant-radio-input:focus-visible + .ant-radio-inner {
            outline-offset: 0px;
            border-color: ${token.colorPrimary};
            background-color: ${!checked &&
            token.color?.Selection?.selectionBgFill};
            outline-color: ${token.color?.bg?.fill?.fillPrimarySubtle};
        }
        .ant-radio-inner.ant-radio-inner {
            width: ${dimension}px;
            height: ${dimension}px;
            display: block;
            z-index: 1;

            :hover {
                background-color: ${!(disabled || checked) &&
                token.color?.Selection?.selectionBgFill};
            }

            &::after {
                transform: scale(0.375) !important;
                ${getRadioDotCss(size, token.colorPrimary, disabled)}
            }
        }
    `;
};

export const StyledRadio = styled(Radio)<{
    size?: string;
}>`
    ${({ size = "medium", disabled = false, checked = false }) =>
        getRadioCSS(size, disabled, checked)}
`;
